import { setRangeMin } from './helpers';

export const setBedroomsCountMin = setRangeMin('bedroom_total');
